<div>
    <app-customer-list> </app-customer-list>
</div>
<div>
    <app-customer-form></app-customer-form>
</div>